import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
const PDPDimensionShotViewer = t0 => {
  const $ = _c(40);
  let className;
  let currentDimensionShot;
  let hasMultipleDimensionShots;
  let imageProps;
  let onNext;
  let onPrevious;
  if ($[0] !== t0) {
    const {
      currentDimensionShot: t1,
      hasMultipleDimensionShots: t2,
      selectedDimensionShotIndex,
      totalDimensionShots,
      onPrevious: t3,
      onNext: t4,
      className: t5,
      ...t6
    } = t0;
    currentDimensionShot = t1;
    hasMultipleDimensionShots = t2;
    onPrevious = t3;
    onNext = t4;
    className = t5;
    imageProps = t6;
    $[0] = t0;
    $[1] = className;
    $[2] = currentDimensionShot;
    $[3] = hasMultipleDimensionShots;
    $[4] = imageProps;
    $[5] = onNext;
    $[6] = onPrevious;
  } else {
    className = $[1];
    currentDimensionShot = $[2];
    hasMultipleDimensionShots = $[3];
    imageProps = $[4];
    onNext = $[5];
    onPrevious = $[6];
  }
  const [imageSrc, setImageSrc] = useState(currentDimensionShot?.src);
  const [hasErrored, setHasErrored] = useState(false);
  let t1;
  if ($[7] !== currentDimensionShot?.src) {
    t1 = () => {
      setImageSrc(currentDimensionShot?.src);
      setHasErrored(false);
    };
    $[7] = currentDimensionShot?.src;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = currentDimensionShot?.src;
  let t3;
  if ($[9] !== t2) {
    t3 = [t2];
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t1, t3);
  let t4;
  if ($[11] !== currentDimensionShot || $[12] !== hasErrored) {
    t4 = () => {
      if (!hasErrored && currentDimensionShot?.baseUrl) {
        setImageSrc(currentDimensionShot.baseUrl);
        setHasErrored(true);
      }
    };
    $[11] = currentDimensionShot;
    $[12] = hasErrored;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleImageError = t4;
  let t5;
  let t6;
  if ($[14] !== hasMultipleDimensionShots || $[15] !== onNext || $[16] !== onPrevious) {
    t5 = () => {
      if (!hasMultipleDimensionShots) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key === "ArrowLeft") {
          onPrevious?.();
        } else {
          if (event.key === "ArrowRight") {
            onNext?.();
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t6 = [hasMultipleDimensionShots, onPrevious, onNext];
    $[14] = hasMultipleDimensionShots;
    $[15] = onNext;
    $[16] = onPrevious;
    $[17] = t5;
    $[18] = t6;
  } else {
    t5 = $[17];
    t6 = $[18];
  }
  useEffect(t5, t6);
  let t7;
  if ($[19] !== imageProps) {
    t7 = imageProps || {};
    $[19] = imageProps;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let lazy;
  let validImgProps;
  if ($[21] !== t7) {
    const {
      enableCrops,
      crops,
      type,
      lazy: t8,
      ...t9
    } = t7;
    lazy = t8;
    validImgProps = t9;
    $[21] = t7;
    $[22] = lazy;
    $[23] = validImgProps;
  } else {
    lazy = $[22];
    validImgProps = $[23];
  }
  let t8;
  if ($[24] !== className) {
    t8 = classNames("relative w-full h-full", className);
    $[24] = className;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== currentDimensionShot || $[27] !== handleImageError || $[28] !== imageSrc || $[29] !== lazy || $[30] !== validImgProps) {
    t9 = currentDimensionShot && <img {...validImgProps} src={imageSrc} alt={`Product dimensions - ${currentDimensionShot.dimensionCode}`} className="h-full w-full object-contain object-center select-none" onError={handleImageError} loading={typeof lazy === "boolean" ? lazy ? "lazy" : "eager" : lazy} />;
    $[26] = currentDimensionShot;
    $[27] = handleImageError;
    $[28] = imageSrc;
    $[29] = lazy;
    $[30] = validImgProps;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== hasMultipleDimensionShots || $[33] !== onNext || $[34] !== onPrevious) {
    t10 = hasMultipleDimensionShots && <><button type="button" onClick={onPrevious} className="group/SliderButton absolute -left-3 md:left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex justify-center items-center bg-white border border-gray-light6 transition-all duration-200 hover:border-brand [&_svg_path]:fill-gray [&_svg_path]:transition-all [&_svg_path]:duration-200 group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]" aria-label="Previous image"><IconArrowLeftWhite width={20} height={20} /><VisuallyHidden>Previous image</VisuallyHidden></button><button type="button" onClick={onNext} className="group/SliderButton absolute -right-3 md:right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full flex justify-center items-center bg-white border border-gray-light6 transition-all duration-200 hover:border-brand [&_svg_path]:fill-gray [&_svg_path]:transition-all [&_svg_path]:duration-200 group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]" aria-label="Next image"><IconArrowRightWhite width={20} height={20} /><VisuallyHidden>Next image</VisuallyHidden></button></>;
    $[32] = hasMultipleDimensionShots;
    $[33] = onNext;
    $[34] = onPrevious;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t8 || $[38] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[36] = t10;
    $[37] = t8;
    $[38] = t9;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
};
PDPDimensionShotViewer.propTypes = {
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    baseUrl: PropTypes.string,
    dimensionCode: PropTypes.string.isRequired
  }),
  hasMultipleDimensionShots: PropTypes.bool,
  selectedDimensionShotIndex: PropTypes.number,
  totalDimensionShots: PropTypes.number,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  className: PropTypes.string
};
export default PDPDimensionShotViewer;